<template>
  <TabNav
    class="TabNavView"
    v-bind="{
      items,
      selectedItem,
      isExact,
    }"
    @update:selectedItem="handleItemSelected"
  />
</template>

<script lang="ts" setup>
import { TabNavItem } from "@cosine/components/TabNav.types";
import TabNav from "@cosine/components/TabNav.vue";
import { ref, toRefs, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

const props = withDefaults(defineProps<{
  items: Array<TabNavItem>,
  isExact?: boolean,
}>(), {
  isExact: false,
});
const router = useRouter();
const route = useRoute();

const {
  items,
} = toRefs(props);
const selectedItem = ref<TabNavItem | null>(findItemByRoute());

function findItemByRoute (): TabNavItem | null {
  const matchedRoutes = route.matched || [];

  return items.value.find((item) => {
    return !!matchedRoutes.find((_route) => item.to.name === _route.name);
  }) || null;
}

watch(route, () => {
  selectedItem.value = findItemByRoute();
});

function handleItemSelected (item: TabNavItem | null) {
  if (item === selectedItem.value) { return; }

  selectedItem.value = item;
  if (selectedItem.value) {
    router.push(selectedItem.value.to);
  }
}
</script>
